import { render, staticRenderFns } from "./CampanhaPasso1.vue?vue&type=template&id=29b874a9"
import script from "./CampanhaPasso1.vue?vue&type=script&lang=js"
export * from "./CampanhaPasso1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports